import Header from "./components/Header";
import HeroAbout from "./components/HeroAbout";
import Products from "./components/Products";
import Contact from "./components/Contact";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Header />
      <HeroAbout />
      <Products />
      <Contact />
    </main>
  );
}
